
export class Metric {
    static types = {
        NotFoundAmateur: "AmateurNotFound",
        DropDialog: "DropDialog",
        DropMessage: "DropMessage",
    }

    static sections = {
        Messenger: 'Messenger',
        AmateurCache: 'AmateurCache',
    }
    /**
     * Creates an instance of the Metric class.
     * @param {string} type - The name of the metric.
     * @param {string} section - The section where the metric was recorded.
     * @param {number} [count=1] - The count associated with the metric.
     * @param {number} [time=Date.now()] - The time associated with the metric in milliseconds.
     */
    constructor(type, section, count = 1, time = Date.now()) {
        this.type = type;
        this.count = count;
        this.time = Math.floor(time / 30000) * 30000; // Round the time to the nearest 30 seconds
        this.section = section;
    }
}
